import Message from '@/Messages/Message';
import ComponentManager from '@/Management/ComponentManager';

export default class ExtensionViewExitedMessage extends Message {

    public constructor(params: any) {
        super(params);
    }
}

ComponentManager.setMessage('ExtensionViewExitedMessage', ExtensionViewExitedMessage, 'RADPresentation.HTMLClient.DefaultViewExtensions');